import './Logo.scss'

import React, { useCallback, useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'

const SIZES = {
  'tiny': 20,
  'small': 24,
  'field-sized': 32,
  'default': 40,
  'medium': 56,
  'large': 72,
  'extra-large': 96
}

const Logo = ({ size, source, alternative, rounded }) => {
  const invalidSource = !source || source.length === 0
  const [renderElement, setRenderElement] = useState(invalidSource && alternative)
  const logoSize = SIZES[size] || SIZES['default']

  const onError = useCallback(() => setRenderElement(alternative), [alternative])

  useEffect(() => setRenderElement(invalidSource && alternative), [invalidSource, alternative])

  return (
    <div
      className={classNames('avatar', { "-rounded": rounded })}
      style={{ width: logoSize, height: logoSize }}
    >
      {invalidSource || renderElement ? (
        renderElement
      ) : (
        <img
          style={{ maxWidth: logoSize, maxHeight: logoSize }}
          alt=''
          src={source}
          onError={onError}
        />
      )}
    </div>
  )
}

Logo.propTypes = {
  source: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'field-sized', 'default', 'medium', 'large', 'extra-large']),
  alternative: PropTypes.object
}

Logo.defaultProps = {
  size: 'default'
}

export default Logo
